import * as zod from 'zod'

export const confirmSchema = zod.object({
  // only applicable to On-Demand Delivery Blocks
  hasAcknowledgedOddbRequirements: zod.boolean().default(false).optional(),
})

export type ConfirmForm = zod.infer<typeof confirmSchema>
